export const styles = {
  link: {
    fontSize: '16px',
    color: '#0C172C',
    textDecoration: 'underline',
    fontFamily: 'Proxima Nova, sans-serif',
    textAlign: 'center',
  },
  text: {
    fontSize: '14px',
  },
  action: {
    textAlign: 'center',
    marginRight: '45px',
  },
  alert: {
    maxWidth: '95%',
    minWidth: '370px',
    margin: '0 auto',
    '& .MuiAlert-message': {
      width: '100% !important',
      justifyContent: 'space-between',
    },
    '& .MuiAlert-icon': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxHeight: '55px',
    },
  },
  container: {
    justifyContent: 'space-between',
  },
}
